import React from 'react'
import Figure from './Figure'

const Slideshow = ({node}) => {
    return (
        <div>
            {node.images.map(image => (
                <Figure node={image} />
            ))}
        </div>
    )
}

export default Slideshow